import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/logo.png'


const _hoisted_1 = { class: "loginContainer" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "logo"
}, null, -1)
const _hoisted_3 = { class: "formContainer p-5 position-relative" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-sm-6" }
const _hoisted_6 = { class: "col-sm-6" }
const _hoisted_7 = { class: "col-sm-6" }
const _hoisted_8 = { class: "col-sm-6" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("hr", { class: "my-4" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_form_field = _resolveComponent("form-field")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_localized_text, {
        type: "h2",
        localizedKey: "Sign up",
        text: "Sign up",
        class: "text-center"
      }),
      _createElementVNode("form", {
        class: "mt-5",
        onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.register && _ctx.register(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_form_field, {
              type: "email",
              modelValue: _ctx.languageCredential.username,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.languageCredential.username) = $event)),
              placeholderKey: "Email",
              placeholderValue: "Email",
              labelKey: "Email",
              labelValue: "Email"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_form_field, {
              class: "pb-3",
              type: "password",
              modelValue: _ctx.languageCredential.password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.languageCredential.password) = $event)),
              placeholderKey: "Password",
              placeholderValue: "Password",
              labelKey: "Password",
              labelValue: "Password"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_form_field, {
              class: "pb-3",
              type: "text",
              modelValue: _ctx.languageCredential.companyName,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.languageCredential.companyName) = $event)),
              placeholderKey: "Company Name",
              placeholderValue: "Company Name",
              labelKey: "Company Name",
              labelValue: "Company Name"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_form_field, {
              type: "select-string",
              labelKey: "Language",
              labelValue: "Language",
              placeholderKey: "Language",
              placeholderValue: "Language",
              list: _ctx.$store.state.consts.enabledLanguages,
              modelValue: _ctx.languageCredential.preferredCulture,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.languageCredential.preferredCulture) = $event))
            }, null, 8, ["list", "modelValue"])
          ])
        ]),
        _createElementVNode("button", {
          type: "submit",
          class: "btn btn-primary text-center justify-content-center w-100 mt-4",
          disabled: _ctx.disabled
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Register",
            text: "Register"
          })
        ], 8, _hoisted_9)
      ], 32),
      _hoisted_10,
      _createVNode(_component_router_link, {
        to: "/login",
        class: "btn btn-secondary text-center justify-content-center w-100"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_localized_text, {
            localizedKey: "Back",
            text: "Back"
          })
        ]),
        _: 1
      })
    ])
  ]))
}